var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdatePassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 18.3359H16.6673",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.574 3.04983L12.1919 2.43191C13.2157 1.40811 14.8757 1.40811 15.8995 2.43191C16.9233 3.45572 16.9233 5.11563 15.8995 6.13943L15.2815 6.75735M11.574 3.04983C11.574 3.04983 11.6513 4.36291 12.8099 5.52151C13.9685 6.68011 15.2815 6.75735 15.2815 6.75735M11.574 3.04983L5.8932 8.73066C5.50843 9.11544 5.31604 9.30782 5.15058 9.51995C4.95541 9.77018 4.78807 10.0409 4.65155 10.3274C4.53581 10.5703 4.44977 10.8284 4.27769 11.3446L3.54852 13.5321M15.2815 6.75735L9.60072 12.4382C9.21594 12.823 9.02356 13.0153 8.81143 13.1808C8.5612 13.376 8.29045 13.5433 8.00397 13.6798C7.76111 13.7956 7.503 13.8816 6.98677 14.0537L4.79926 14.7829M4.79926 14.7829L4.26455 14.9611C4.0105 15.0458 3.73042 14.9797 3.54107 14.7903C3.35172 14.601 3.2856 14.3209 3.37028 14.0668L3.54852 13.5321M4.79926 14.7829L3.54852 13.5321",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatePassword);
export default __webpack_public_path__ + "static/media/UpdatePassword.6d3c934fa6fb2cee986aaddb0fd057a9.svg";
export { ForwardRef as ReactComponent };